module.exports = __webpack_public_path__ + "img/vkus.3e36a32a.svg";